import React, { FC } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import styled from 'styled-components';

const DraggableListContainer = styled.div`
  > div:not(:last-child) section {
    box-shadow: none;
    border-radius: 0;
  }

  > div:last-child > div {
    border-bottom-left-radius: ${({ theme }) => theme.misc.tileBRadius};
    border-bottom-right-radius: ${({ theme }) => theme.misc.tileBRadius};
  }
`;

interface OwnProps {
  renderTemplate: (item: any) => React.ReactNode;
  list: any[];
  onListChange: (list: any[], result: DropResult) => void;
  listKey?: string;
}

const DragList: FC<OwnProps> = (props) => {
  const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }
    const list = reorder(props.list, result.source.index, result.destination.index);
    props.onListChange(list, result);
  };

  const { listKey = 'id' } = props;
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <DraggableListContainer ref={provided.innerRef} className="draggable-list">
            {props.list.map((item, index) => (
              <Draggable key={item[listKey]} draggableId={item[listKey]} index={index}>
                {(provided1) => (
                  <>
                    <div
                      ref={provided1.innerRef}
                      {...provided1.draggableProps}
                      {...provided1.dragHandleProps}
                    >
                      {props.renderTemplate(item)}
                    </div>
                    {provided1.placeholder}
                  </>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </DraggableListContainer>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragList;
